import actionTypes from "../actionTypes";
import initialState from "./initialState";

export default function (state = initialState.settings, action) {
  switch (action.type) {
    case actionTypes.LOAD_VENUE_INFO:
      return {
        ...action.settings,
        welcome: action.welcome,
      };
    case actionTypes.UPDATE_WELCOME:
      return {
        ...state,
        welcome: action.welcome,
      };
    case actionTypes.SET_PACKING_COST:
      return {
        ...state,
        packing_cost: action.packing_cost,
      };
    case actionTypes.SET_DELIVERY_SETTINGS:
      return {
        ...state,
        delivery_settings: action.delivery,
      };
    case actionTypes.SET_CURRENCY:
      return {
        ...state,
        currency: action.value,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js